var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShowBtn
    ? _c(
        "div",
        [
          _c("transition", { attrs: { name: "addScreen" } }),
          _c("div", { staticClass: "pwa-prompt-wrap safari active" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-install",
                attrs: { href: "javascript:;" },
                on: { click: _vm.showGuide },
              },
              [_vm._v(_vm._s(_vm.$t("add-to-screen")))]
            ),
          ]),
          _c("transition", { attrs: { name: "iosGuide" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isShowGuide,
                    expression: "isShowGuide",
                  },
                ],
                staticClass: "ios-guide",
                class: { active: _vm.isShowGuide },
                on: {
                  click: function ($event) {
                    _vm.isShowGuide = false
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "guide-wrap",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "close",
                      on: {
                        click: function ($event) {
                          _vm.isShowGuide = false
                        },
                      },
                    }),
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("ios-guide-1"))),
                    ]),
                    _c("div", { staticClass: "subtitle" }, [
                      _vm._v(
                        _vm._s(_vm.$t("ios-guide-2")) +
                          " " +
                          _vm._s(_vm.$t("ios-guide-3"))
                      ),
                    ]),
                    _c("div", { staticClass: "logo" }),
                    _c("div", { staticClass: "game" }, [
                      _vm._v("State Of Survival"),
                    ]),
                    _c("div", { staticClass: "phone" }),
                    _c(
                      "i18n",
                      {
                        staticClass: "txt",
                        attrs: { path: "ios-guide-4", tag: "div" },
                      },
                      [
                        _c("div", {
                          staticClass: "up",
                          attrs: { slot: 0 },
                          slot: 0,
                        }),
                      ]
                    ),
                    _c(
                      "i18n",
                      {
                        staticClass: "txt",
                        attrs: { path: "ios-guide-5", tag: "div" },
                      },
                      [
                        _c("div", {
                          staticClass: "add",
                          attrs: { slot: 0 },
                          slot: 0,
                        }),
                        _c("template", { slot: 1 }, [
                          _vm._v(_vm._s(_vm.$t("ios-guide-1"))),
                        ]),
                      ],
                      2
                    ),
                    _c("div", { staticClass: "mune" }, [
                      _c("div", [_vm._v(_vm._s(_vm.$t("ios-guide-1")))]),
                    ]),
                    _c("div", { staticClass: "arr" }),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }